module.exports = __webpack_public_path__ + "assets/quiz-black.3c1599ab.svg";